/* unplugin-vue-components disabled */import { render } from "./MixImageSwiper.vue?vue&type=template&id=3cdc38eb"
import script from "./MixImageSwiper.vue?vue&type=script&lang=js"
export * from "./MixImageSwiper.vue?vue&type=script&lang=js"

import "./MixImageSwiper.vue?vue&type=style&index=0&id=3cdc38eb&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__